export const Status = {
  NEW: 'NE',
  INPROGRESS: 'IP',
  COMPLETE: 'CO',
};

export default Status;



// WEBPACK FOOTER //
// ./data/WritingAssignment/status.js